import { PlayCircle, ArrowUpRight } from "lucide-react";
import { useTranslation } from "../context/LanguageContext";
import { helpCenterUrl } from "../utils/helpCenter";

/** Link to the video help center, shown on the support/contact/help pages. */
export default function VideoTutorialsCard({ className = "" }: { className?: string }) {
  const { t, currentLanguage } = useTranslation();
  return (
    <a
      href={helpCenterUrl(currentLanguage)}
      target="_blank"
      rel="noreferrer"
      className={`group flex items-center gap-3 rounded-lg border border-primary-200 dark:border-primary-800/60 bg-primary-50 dark:bg-primary-900/20 p-3 transition-colors hover:border-primary-400 dark:hover:border-primary-600 ${className}`}
    >
      <PlayCircle className="text-primary-600 dark:text-primary-300 flex-shrink-0" size={22} />
      <div className="flex-1 min-w-0">
        <p className="text-sm font-semibold text-gray-900 dark:text-white">{t("support.videoTutorials")}</p>
        <p className="text-xs text-gray-500 dark:text-dark-400 mt-0.5">{t("support.videoTutorialsDescription")}</p>
      </div>
      <ArrowUpRight size={16} className="text-primary-500 dark:text-primary-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
    </a>
  );
}
